import type { IdentityFilter, StatusFilter } from '../api/types'

/** Which CofA side the page is focused on. Drives both the row filter
 *  (only show rows with that kind populated) and which preview tab the
 *  drawer opens to when a row is clicked. `all` keeps every row and
 *  defaults the drawer to the vendor tab. */
export type CofaKindFilter = 'all' | 'vendor' | 'spi'

export interface CofaClientFilters {
  status: StatusFilter
  identity: IdentityFilter
  vendorQuery: string
  productQuery: string
  spiOnly: boolean
  excludeBothMissing: boolean
  docKinds: ReadonlySet<string>
  cofaKind: CofaKindFilter
  /** Also list used-up lots (no stock). The KPIs always count lots in stock. */
  includeUsedUp: boolean
}

export const DEFAULT_FILTERS: CofaClientFilters = {
  status: 'all',
  identity: 'all',
  vendorQuery: '',
  productQuery: '',
  spiOnly: false,
  excludeBothMissing: false,
  docKinds: new Set(['cofa']),
  cofaKind: 'all',
  includeUsedUp: false,
}

export function countActiveFilters(f: CofaClientFilters): number {
  let n = 0
  if (f.status !== 'all') n += 1
  if (f.identity !== 'all') n += 1
  if (f.vendorQuery.trim()) n += 1
  if (f.productQuery.trim()) n += 1
  if (f.spiOnly) n += 1
  if (f.excludeBothMissing) n += 1
  if (f.docKinds.size !== 1 || !f.docKinds.has('cofa')) n += 1
  if (f.cofaKind !== 'all') n += 1
  if (f.includeUsedUp) n += 1
  return n
}
